<div class="request-list-container">
  <div class="request-list-header">
    <h2 class="list-title">{{ showHistory ? 'Geçmiş İşlem Kayıtları' : 'Talepler' }}</h2>
    <button class="refresh-button" (click)="onRefresh()" *ngIf="!showHistory" title="Yenile">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2" />
      </svg>
    </button>
    <div class="live-indicator" *ngIf="!showHistory">
      <span class="live-dot"></span>
      <span class="live-text">Canlı</span>
    </div>
  </div>

  <!-- Geçmiş: mobilde kart, masaüstünde tablo -->
  <div class="history-cards" *ngIf="showHistory">
    <div *ngFor="let request of requests" class="history-card" (click)="onSelectRequest(request)"
      [class.timeout-row]="request.status === 'timeout' || request.status === 'timeout_out_of_hours'">
      <div class="history-card-row">
        <span class="history-card-label">Misafir</span>
        <span class="history-card-value guest-name">{{ request.customer_name }}</span>
      </div>
      <div class="history-card-row">
        <span class="history-card-label">Telefon</span>
        <span class="history-card-value phone">{{ request.phone_number }}</span>
      </div>
      <div class="history-card-row">
        <span class="history-card-label">Lokasyon</span>
        <span class="history-card-value location">{{ request.location_details || request.location }}</span>
      </div>
      <div class="history-card-row">
        <span class="history-card-label">Durum</span>
        <span class="status-badge" [class.status-responded]="request.status === 'responded'"
          [class.status-rejected]="request.status === 'rejected' || request.status === 'cancelled'"
          [class.status-timeout]="request.status === 'timeout' || request.status === 'timeout_out_of_hours'">
          {{ getStatusText(request.status) }}
        </span>
      </div>
      <div class="history-card-row">
        <span class="history-card-label">Yanıt</span>
        <span class="response-badge" *ngIf="request.response_time">{{ request.response_time }} dk</span>
        <span class="no-response" *ngIf="!request.response_time">—</span>
      </div>
      <div class="history-card-row date-time">
        <span>{{ formatDate(request.response_sent_at || request.updated_at) }}</span>
        <span>{{ formatTime(request.response_sent_at || request.updated_at) }}</span>
      </div>
    </div>
    <div class="empty-state" *ngIf="requests.length === 0">
      <p>Geçmiş talep bulunmuyor</p>
    </div>
  </div>

  <div class="history-table-container" *ngIf="showHistory">
    <table class="history-table">
      <thead>
        <tr>
          <th>MİSAFİR</th>
          <th>TELEFON</th>
          <th>LOKASYON</th>
          <th>DURUM</th>
          <th>VERİLEN YANIT</th>
          <th>TARİH</th>
          <th>İŞLEM SAATİ</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let request of requests" (click)="onSelectRequest(request)"
          [class.timeout-row]="request.status === 'timeout' || request.status === 'timeout_out_of_hours'">
          <td class="guest-name">{{ request.customer_name }}</td>
          <td class="phone">{{ request.phone_number }}</td>
          <td class="location">{{ request.location_details || request.location }}</td>
          <td class="status">
            <span class="status-badge" [class.status-responded]="request.status === 'responded'"
              [class.status-rejected]="request.status === 'rejected' || request.status === 'cancelled'"
              [class.status-timeout]="request.status === 'timeout' || request.status === 'timeout_out_of_hours'">
              {{ getStatusText(request.status) }}
            </span>
          </td>
          <td class="response">
            <span class="response-badge" *ngIf="request.response_time">
              {{ request.response_time }} dk
            </span>
            <span class="no-response" *ngIf="!request.response_time">-</span>
          </td>
          <td class="date">{{ formatDate(request.response_sent_at || request.updated_at) }}</td>
          <td class="time">{{ formatTime(request.response_sent_at || request.updated_at) }}</td>
        </tr>
      </tbody>
    </table>

    <div class="empty-state" *ngIf="requests.length === 0">
      <p>Geçmiş talep bulunmuyor</p>
    </div>
  </div>

  <!-- Waiting Requests List View -->
  <div class="request-list" *ngIf="!showHistory">
    <div *ngFor="let request of requests" class="request-item" [class.selected]="isSelected(request)"
      (click)="onSelectRequest(request)">
        <div class="request-info">
        <div class="request-name" [title]="request.customer_name">{{ formatName(request.customer_name) }}</div>
        <div class="request-location">
          <svg class="location-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
            <circle cx="12" cy="10" r="3" />
          </svg>
          <span>{{ request.location_details || request.location }}</span>
        </div>
      </div>
      <div class="request-actions">
        <button class="immediate-btn">
          HEMEN
        </button>

        <div class="countdown-badge" *ngIf="shouldShowCountdown(request)">
          <svg class="countdown-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3 2" />
          </svg>
          <span>{{ getCountdownDisplay(request) }}</span>
        </div>
      </div>
    </div>

    <div class="empty-state" *ngIf="requests.length === 0">
      <p>Bekleyen talep bulunmuyor</p>
    </div>
  </div>
</div>